import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../../Components/consts'

export const LeaderboardHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 15,
  paddingBottom: 5,
  position: 'relative',
  minHeight: 38,
  [theme.breakpoints.down('sm')]: {
    marginBottom: 10,
    paddingBottom: 5,
    minHeight: 28,
  },
}))

export const LeaderboardTitle = styled('h2')(({ theme }) => ({
  fontSize: fontSizes.large,
  fontWeight: 'bold',
  margin: 0,
  color: colors.text,
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.medium,
  },
}))

export const LocationSelect = styled('select')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  opacity: 0,
  cursor: 'pointer',
  border: 'none',
  padding: 0,
  margin: 0,
})

export const DropdownArrowIcon = styled('span')({
  fontSize: fontSizes.large,
  color: colors.gray.gray90,
})
